import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Sidebar from './Sidebar';
import Dashboard from './Dashboard/Dashboard';

import ManageStaff from './ManageStaff/ManageStaff';
import ManageArea from './ManageArea/ManageArea';
import ManageEvent from './ManageEvent/ManageEvent';
import ManageSkills from './ManageSkills/ManageSkills';
import ManageStaffSkills from './ManageStaffSkill/ManageStaffSkills';
import ManageEventType from './ManageEventType/ManageEventType';
// import DutyAllotement from './DutyAllotment/DutyAllotement';
import AvailableDeputy from './AvailableDeputy';
import { useSelector } from 'react-redux';
import GeoTag from './GeoTag/GeoTag';
import StafGeoTagList from './StafGeoTagList';
import DummyCheckInDMS from './DummyCheckInDMS';
import DutyAllotementt from './DutyAllotment/DutyAllotementt';
import ViewAllotement from './CrystalReport/ViewAllotement';
import DeputyLocation from './DeputyLocation/DeputyLocation';
import AreaUpdateComponent from './ManageArea/AreaUpdateComponent';
import ReserveDeputyBase from './ReserveDeputy/ReserveDeputyBase';
import CheckPointLists from './ReserveDeputy/ManageCheckPoints/CheckPointList';
import ReserveDutyAllotementBase from './ReserveDeputyAllotement/ReserveDutyAllotementParts/ReserveDutyAllotementBase';






const AdminPanel = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const Merchanttoken =  useSelector((state) => state.auth.token);



  return (
    <div className="relative xl:flex  h-screen   ">

      <div
        className={`fixed z-10 top-0 left-0  h-screen bg-white-800 text-white transform transition-transform   -translate-x-full xl:relative xl:translate-x-0 xl:w-64 xl:block`}
      >
        <Sidebar />
      </div>



      {/* Main content area */}
      <div className="flex-1  border border-b-4  overflow-y-auto ">
        <Routes>
          <Route path= {`${Merchanttoken}/`} element={<Dashboard />} />
          <Route path= {`${Merchanttoken}/dashboard`} element={<Dashboard />} />
          <Route path={`${Merchanttoken}/manageStaff`} element={<ManageStaff/>} />

  <Route path={`${Merchanttoken}/Updated-manageArea`} element={<AreaUpdateComponent/>} />

          {/* <Route path={`${Merchanttoken}/manageArea`} element={<ManageArea/>} /> */}
          <Route path="/:token/manageArea" element={<ManageArea />} />



          <Route path={`${Merchanttoken}/manageEvent`} element={<ManageEvent/>} />
          <Route path={`${Merchanttoken}/manageSkills`} element={<ManageSkills/>} />
          <Route path={`${Merchanttoken}/Staff-Skill`} element={<ManageStaffSkills/>} />
          <Route path={`${Merchanttoken}/manageEventType`} element={<ManageEventType/>} />
          <Route path={`${Merchanttoken}/geo-tag`} element={<GeoTag/>} />
          <Route path={`${Merchanttoken}/GeoTagList`} element={<StafGeoTagList/>} />

          <Route path={`${Merchanttoken}/availableDeputy`} element={<AvailableDeputy/>} />
          <Route path={`${Merchanttoken}/AllotmentList`} element={<DutyAllotementt/>} />
          <Route path={`${Merchanttoken}/dummyCheck`} element={<DummyCheckInDMS/>} />
          <Route path={`${Merchanttoken}/Allotment`} element={<DutyAllotementt/>} />
          <Route path={`${Merchanttoken}/view-Allotment`} element={<ViewAllotement/>} />
          <Route path={`${Merchanttoken}/deputy-location`} element={<DeputyLocation/>} />
          <Route path={`${Merchanttoken}/ReserveDeputy`} element={<ReserveDeputyBase/>} />

           <Route path={`${Merchanttoken}/CheckpointList`} element={<CheckPointLists/>} />
           <Route path={`${Merchanttoken}/reserveDeputyAllotement`} element={<ReserveDutyAllotementBase/>} />







          {/* StafGeoTagList */}


        </Routes>
      </div>
      
    </div>
  );
};

export default AdminPanel;
